// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HotUserRegistrationInput_wrapper__3GgSc"};